<template>
  <div style="padding: 15px">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="可用余额">
            <el-input v-model="balanceList.availableAmount" placeholder="请输入金额" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="bankCardNumber" label="银行卡号">
            <el-input v-model="balanceList.bankCardNumber" placeholder="请输入银行卡号" disabled />
          </el-form-item>
          <el-form-item prop="transferAmount" label="申请提现金额">
            <el-input v-model="form.transferAmount" placeholder="请输入本次申请提现金额" @input="(value)=>formFormatter.isFloor2(value,oldValue,form,'transferAmount')">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="memo" label="备注">
            <el-input v-model="form.memo" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-button type="primary" @click="addClick()">提现</el-button>
    </el-form>
  </div>
</template>
<script>
import {
   arpaWithdraw,
} from "@/api/merchantCenter";
export default {
  name: "BalanceAmount",
 
  props: {
    balanceList: {
      type: Object,
      default() {
        return {
        }
      }
    }
  },
  data() {
    return {
      show:true,
       count: "",
      form: {
        memo : "",
      },
      rules: {
       transferAmount: [
          { required: true, message: "请输入本次提现", trigger: "blur" }
        ],

        
      }
    };
  },
  created() {
  },
  mounted(){
    //  this.$refs.form.resetFields()
  },
  methods: {
    //提交
    addClick() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
           var data = Object.assign({}, this.form, { code: this.balanceList.code, partyCode: this.balanceList.partyCode })
           arpaWithdraw(data,'post').then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
          }).finally(()=>{
              rLoading.close();
              this.$emit("event2");
              this.$refs.form.resetFields();
          });
        } else {
          return false;
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
</style>
